export const colors = [
    "#ffc10775",
    "#eeeeee",
    "rgba(90,178,255,0.6)",
    "rgba(255,105,145,0.6)",
    "rgba(155,100,210,0.6)",
    "rgba(250,55,197,0.6)",
  ];
  